module.exports = __webpack_public_path__ + "static/img/img_media08.da38801.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_mobile/img_media08.png
// module id = Dl9P
// module chunks = 0